<template>
  <article>
    <users-delete-data-requests
      @setTotalDeleteDataRequest="setTotalDeleteDataRequest"
      @updateUsersDeleteDataRequestsHistoryTable="updateUsersDeleteDataRequestsHistoryTable"
      @updateQuitClubRequestsHistoryTable="updateQuitClubRequestsHistoryTable"
    />
    <users-delete-data-requests-history ref="UsersDeleteDataRequestsHistory" />
  </article>
</template>

<script>
import UsersDeleteDataRequests from '@/modules/clientes/gerenciamento/views/components/UsersDeleteDataRequests.vue'
import UsersDeleteDataRequestsHistory from '@/modules/clientes/gerenciamento/views/components/UsersDeleteDataRequestsHistory.vue'

export default {
  name: 'CustomersManagementRequests',

  components: {
    UsersDeleteDataRequests,
    UsersDeleteDataRequestsHistory,
  },

  mounted() {
    this.$emit('updateTotalDeleteDataRequest')
  },

  methods: {
    updateUsersDeleteDataRequestsHistoryTable() {
      this.$refs.UsersDeleteDataRequestsHistory.updateUsersDeleteDataRequestsHistoryTable()
    },

    updateQuitClubRequestsHistoryTable() {
      this.$refs.UsersDeleteDataRequestsHistory.updateQuitClubRequestsHistoryTable()
    },

    setTotalDeleteDataRequest(total) {
      this.$emit('setTotalDeleteDataRequest', total)
    },
  },
}
</script>
